import { defineComponent, computed } from "vue";
import DropdownItemContent from "./component-library76.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "dropdown-item",
  props: {
    url: { default: void 0 },
    selected: { type: Boolean },
    label: { default: void 0 },
    value: { default: void 0 },
    count: { default: void 0 },
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const hasLink = computed(() => !!props.url && !props.disabled);
    const onClick = (e) => {
      e.preventDefault();
      if (props.disabled)
        return;
      emit("click", props.value);
    };
    expose({
      hasLink
    });
    return { __sfc: true, props, emit, hasLink, onClick, DropdownItemContent, LinkButton };
  }
});
export {
  _sfc_main as default
};
